// Bloqueo temporal (mantenimiento). El estado viene de GET /api/mantenimiento.

export const hayBloqueo = estado => !!(estado && (estado.bloquear_creacion || estado.bloquear_pasarela));

// Qué está bloqueado, en palabras, para el aviso del dashboard.
export const queSeBloquea = estado => {
  if (!estado) return '';
  if (estado.bloquear_creacion && estado.bloquear_pasarela) return 'la creación de procesos y la pasarela de firma';
  if (estado.bloquear_creacion) return 'la creación de procesos';
  if (estado.bloquear_pasarela) return 'la pasarela de firma';
  return '';
};

const dos = n => String(n).padStart(2, '0');

// ISO 8601 (UTC) → valor de <input type="datetime-local"> en hora local; '' si no hay fecha válida.
export const aInputLocal = iso => {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return `${d.getFullYear()}-${dos(d.getMonth() + 1)}-${dos(d.getDate())}T${dos(d.getHours())}:${dos(d.getMinutes())}`;
};

// Valor de <input type="datetime-local"> (hora local) → ISO 8601 en UTC; null si está vacío o es inválido.
export const aIso = local => {
  if (!local) return null;
  const d = new Date(local);
  return Number.isNaN(d.getTime()) ? null : d.toISOString();
};

// Formulario → cuerpo del POST.
export const armarCuerpo = ({ bloquear_creacion, bloquear_pasarela, mensaje, hasta }) => ({
  bloquear_creacion: !!bloquear_creacion,
  bloquear_pasarela: !!bloquear_pasarela,
  mensaje: (mensaje || '').trim(),
  hasta: aIso(hasta),
});
